import { Component, inject } from '@angular/core'
import { RouterOutlet } from '@angular/router'

import { ActiveRoute } from '@core/navigation'
import { Header } from './components/header/header'
import { Nav } from './components/nav/nav'
import { SectionHeader } from './components/section-header/section-header'

@Component({
  selector: 'layout',
  imports: [RouterOutlet, Header, Nav, SectionHeader],
  host: { class: 'flex min-h-dvh flex-1 flex-col' },
  templateUrl: './layout.html'
})
export class Layout {
  protected readonly activeRoute = inject(ActiveRoute)
}
